import { Controller } from "@hotwired/stimulus";

export class CertificationListController extends Controller {
  static targets = ["academy", "certification", "list", "hidden"];

  connect() {
    this.syncFromHidden();
  }

  add() {
    const academyId = this.academyTarget.value;
    const certificationId = this.certificationTarget.value;
    const academyName = this.academyTarget.selectedOptions[0]?.text || "";
    const certificationName =
      this.certificationTarget.selectedOptions[0]?.text || "";

    if (!academyId || !certificationId) return;

    this.addItem(academyId, academyName, certificationId, certificationName);
    this.certificationTarget.innerHTML = '<option value=""></option>';
    this.academyTarget.selectedIndex = 0;
    this.academyTarget.focus();
    this.updateHidden();
  }

  addItem(academyId, academyName, certificationId, certificationName) {
    const li = document.createElement("li");
    li.className = "dynamic-list__item";
    li.dataset.academyId = academyId;
    li.dataset.certificationId = certificationId;

    const textSpan = document.createElement("span");
    textSpan.className = "dynamic-list__text";
    textSpan.textContent = `${certificationName} - ${academyName}`;

    const actions = document.createElement("div");
    actions.className = "dynamic-list__actions";

    const removeBtn = document.createElement("button");
    removeBtn.type = "button";
    removeBtn.className = "dynamic-list__btn-remove";
    removeBtn.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>`;
    removeBtn.dataset.action = "click->certification-list#remove";

    actions.appendChild(removeBtn);
    li.appendChild(textSpan);
    li.appendChild(actions);
    this.listTarget.appendChild(li);
  }

  remove(event) {
    const item = event.currentTarget.closest(".dynamic-list__item");
    if (item) {
      item.remove();
      this.updateHidden();
    }
  }

  updateHidden() {
    const items = [];
    this.listTarget.querySelectorAll(".dynamic-list__item").forEach((li) => {
      items.push({
        academy_id: li.dataset.academyId,
        certification_id: li.dataset.certificationId,
      });
    });
    this.hiddenTarget.value = JSON.stringify(items);
  }

  syncFromHidden() {
    const raw = this.hiddenTarget.value;
    if (!raw) return;
    try {
      const items = JSON.parse(raw);
      if (Array.isArray(items)) {
        this.listTarget.innerHTML = "";
        items.forEach((item) => {
          this.addItem(
            item.academy_id,
            item.academy_name || item.academy_id,
            item.certification_id,
            item.certification_name || item.certification_id,
          );
        });
      }
    } catch {
      // Ignore malformed JSON
    }
  }
}
